import { Injectable } from '@angular/core';
import { TenantConfigService } from '@services/tenant-config/tenant-config.service';
import { PrescriptionNodeValue } from 'src/app/shared/models/prescription/prescription-node-value.model';
import { PrescriptionRequestDto } from 'src/app/shared/models/prescription/prescription-request-dto.model';
import { QueryService } from 'src/app/shared/services/query/query.service';

import { Logger } from '@common/logging/logger';
import { CreatePlainPrescriptionHandler } from './prescription-chain-create-plain-prescription-handler';
import { DoctorHandler } from './prescription-chain-doctor-handler';
import { GroupByFlatChargeHandler } from './prescription-chain-group-by-flat-charge-handler';
import { GroupByPrescriptionTypeHandler } from './prescription-chain-group-by-prescription-type-handler';
import { Max3ArticlesPerPrescriptionHandler } from './prescription-chain-max-3-articles-handler';
import { MedicalAidHandler } from './prescription-chain-medical-aid-handler';
import { PatientHandler } from './prescription-chain-patient-handler';
import { PayerHandler } from './prescription-chain-payer-handler';

export interface IPrescriptionChain {
  handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue);
}

@Injectable({ providedIn: 'root' })
export class PrescriptionChain implements IPrescriptionChain {
  constructor(
    private _queryService: QueryService,
    private _tenantConfigService: TenantConfigService,
    private _logger: Logger
  ) {}

  handleRequest(prescriptionRequestDto: PrescriptionRequestDto, request: PrescriptionNodeValue) {
    const createPlainPrescriptionHandler = new CreatePlainPrescriptionHandler();
    const groupByPrescriptionTypeHandler = new GroupByPrescriptionTypeHandler();
    const medicalAidHandler = new MedicalAidHandler(this._queryService, this._tenantConfigService);
    const groupByFlatChargeHandler = new GroupByFlatChargeHandler(this._queryService);
    const max3ArticlesPerPrescriptionHandler = new Max3ArticlesPerPrescriptionHandler();
    const doctorHandler = new DoctorHandler(this._queryService);
    const patientHandler = new PatientHandler(this._queryService, this._logger);
    const payerHandler = new PayerHandler(this._queryService);

    // order of chain is important!
    createPlainPrescriptionHandler
      .setNext(groupByPrescriptionTypeHandler)
      .setNext(medicalAidHandler)
      .setNext(groupByFlatChargeHandler)
      .setNext(max3ArticlesPerPrescriptionHandler)
      .setNext(doctorHandler)
      .setNext(patientHandler)
      .setNext(payerHandler);

    return createPlainPrescriptionHandler.handleRequest(prescriptionRequestDto, request);
  }
}
